import { jsx, jsxs } from "react/jsx-runtime";
import { connectToEditor } from "../withEditorProps";
import {
  Popover,
  Position,
  Tooltip,
  Icon as BpIcon,
  AnchorButton,
  Intent
} from "@blueprintjs/core";
import React from "react";
import "./style.css";
import { noop } from "lodash-es";
class ToolbarItem extends React.Component {
  toggleDropdown = ({ forceClose } = {}) => {
    const { toolName, isOpen } = this.props;
    this.props.openToolbarItemUpdate(isOpen || forceClose ? "" : toolName);
  };
  render() {
    const { overrides = {} } = this.props;
    const {
      isOpen,
      index,
      Icon,
      // dynamicIcon,
      onIconClick = noop,
      tooltip = "",
      tooltipToggled,
      dropdowntooltip = "",
      Dropdown,
      disabled,
      isHidden,
      renderIconAbove,
      noDropdownIcon,
      IconWrapper,
      editorName,
      popoverDisabled,
      IconWrapperProps,
      toolName,
      dropdownicon,
      tooltipDisabled,
      toggled = false,
      ...rest
    } = { ...this.props, ...overrides };
    if (!toolName) console.warn("toolName is required!");
    if (isHidden) return null;
    let tooltipToDisplay = tooltip;
    if (toggled && tooltipToggled) {
      tooltipToDisplay = tooltipToggled;
    }
    const buttonTarget = /* @__PURE__ */ jsxs(
      "div",
      {
        className: `veToolbarItemOuter ve-tool-container-${toolName}` + (disabled ? " disabled " : ""),
        children: [
          renderIconAbove && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("div", { className: "veToolbarItem", children: Icon }) }),
          Icon && !renderIconAbove && /* @__PURE__ */ jsx(
            Tooltip,
            {
              disabled: tooltipDisabled,
              portalClassName: "ve-toolbar-item-popover",
              content: tooltipToDisplay,
              children: /* @__PURE__ */ jsx(
                AnchorButton,
                {
                  intent: Intent.PRIMARY,
                  onClick: onIconClick === "toggleDropdown" ? this.toggleDropdown : onIconClick,
                  active: toggled,
                  disabled,
                  minimal: true,
                  icon: React.isValidElement(Icon) ? Icon : /* @__PURE__ */ jsx(Icon, { toggleDropdown: this.toggleDropdown })
                }
              )
            }
          ),
          Dropdown && !noDropdownIcon ? /* @__PURE__ */ jsx(Tooltip, { disabled: tooltipDisabled, content: dropdowntooltip, children: /* @__PURE__ */ jsx(
            "div",
            {
              className: (isOpen ? " isOpen " : "") + (dropdownicon ? "" : " veToolbarDropdown"),
              onClick: this.toggleDropdown,
              children: dropdownicon ? /* @__PURE__ */ jsx("div", { className: "veToolbarIcon", children: /* @__PURE__ */ jsx("div", { children: dropdownicon }) }) : isOpen ? /* @__PURE__ */ jsx(
                BpIcon,
                {
                  "data-test": toolName + "Dropdown",
                  iconSize: 13,
                  icon: "caret-up"
                }
              ) : /* @__PURE__ */ jsx(
                BpIcon,
                {
                  "data-test": toolName + "Dropdown",
                  iconSize: 13,
                  icon: "caret-down"
                }
              )
            }
          ) }) : null
        ]
      }
    );
    const content = /* @__PURE__ */ jsx(
      "div",
      {
        ref: (n) => {
          if (n) this.dropdownNode = n;
        },
        style: { padding: 10, minWidth: 250, maxWidth: 350 },
        className: "ve-toolbar-dropdown content",
        children: Dropdown && /* @__PURE__ */ jsx(
          Dropdown,
          {
            ...rest,
            editorName,
            toggleDropdown: this.toggleDropdown
          }
        )
      }
    );
    const target = IconWrapper ? /* @__PURE__ */ jsx(IconWrapper, { ...IconWrapperProps, children: ({ getRootProps, getInputProps }) => /* @__PURE__ */ jsxs("div", { ...getRootProps(), children: [
      /* @__PURE__ */ jsx("input", { ...getInputProps() }),
      buttonTarget
    ] }) }) : buttonTarget;
    return /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center" }, children: [
      index !== 0 && /* @__PURE__ */ jsx("div", { className: "veToolbarSpacer" }),
      /* @__PURE__ */ jsx(
        Popover,
        {
          disabled: popoverDisabled,
          isOpen: !!Dropdown && isOpen,
          onClose: (e) => {
            let srcElement;
            if (e) {
              srcElement = e.srcElement || e.target;
            }
            if (e && srcElement && this.dropdownNode && (this.dropdownNode.contains(srcElement) || !document.body.contains(srcElement))) {
              return;
            }
            this.toggleDropdown({ forceClose: true });
          },
          canEscapeKeyClose: true,
          minimal: true,
          position: Position.BOTTOM,
          target,
          content
        }
      )
    ] });
  }
}
export default connectToEditor(({ toolBar = {} }, { toolName }) => ({
  isOpen: toolBar.openItem === toolName
}))(ToolbarItem);
